<div *ngIf="value != null" class="container">

    <div class="block-title">
        <div class="title">{{ getResourceGoods() | translate:{ value: getCount() } }}</div>
    </div>

    <div class="ecmr-block deliveryLines">
        <span class="ecmr-block-title">{{ 'ECMR.DELIVERYLINES.TITLE' | translate }}</span>
        <div class="ecmr-block-content" *ngIf="value.deliveryLines">
        <div class="ecmr-block-row" *ngFor="let line of value.deliveryLines | sortBy:'order'; let i=index">
            <shared-route-cmr-delivery-line class="line compact" [readonly]="true"
            [lineObject]="line"></shared-route-cmr-delivery-line>
        </div>
        </div>
    </div>

    <div class="dummy"></div>
</div>